export type TenantConfig = {
  code: 'ACC' | 'MARONEK' | 'AIDAM'
  companyId: string
  domains: string[]
  legalName: string
  tradeName: string
  email: string
  logoUrl: string
  primaryColor: string
}

const tenants: TenantConfig[] = [
  {
    code: 'ACC',
    companyId: '9d7f1929-69a2-48c9-b0d0-54f1016951fc',
    domains: ['aishacuelloconstructora.com', 'www.aishacuelloconstructora.com'],
    legalName: 'Aisha Cuello Constructora SRL',
    tradeName: 'Aisha Cuello Constructora',
    email: 'info@aishacuelloconstructora.com',
    logoUrl: 'https://wgzwlmkyeydsegzjzlll.supabase.co/storage/v1/object/public/company-assets/logo/9d7f1929-69a2-48c9-b0d0-54f1016951fc/company-logo.png',
    primaryColor: '#002446',
  },
  {
    code: 'MARONEK',
    companyId: 'b80cffe8-fa56-443e-82bb-a28b2457118b',
    domains: ['maronekcorporation.com', 'www.maronekcorporation.com'],
    legalName: 'Maronek Corporación, S.R.L.',
    tradeName: 'Maronek Corporation',
    email: 'info@maronekcorporation.com',
    logoUrl: 'https://wgzwlmkyeydsegzjzlll.supabase.co/storage/v1/object/public/company-assets/logo/b80cffe8-fa56-443e-82bb-a28b2457118b/company-logo.png',
    primaryColor: '#002446',
  },
  {
    code: 'AIDAM',
    companyId: 'e3da40be-731f-421d-b63c-20f798eb3c17',
    domains: ['aidaminversiones.com', 'www.aidaminversiones.com'],
    legalName: 'Aidam Inversiones, S.R.L.',
    tradeName: 'Aidam Inversiones',
    email: 'hola@aidaminversiones.com',
    logoUrl: 'https://wgzwlmkyeydsegzjzlll.supabase.co/storage/v1/object/public/company-assets/logo/e3da40be-731f-421d-b63c-20f798eb3c17/company-logo.png',
    primaryColor: '#002446',
  },
]

function isPreviewHost(hostname: string) {
  const host = hostname.toLowerCase().replace(/:\d+$/, '')
  return host === 'localhost' || host === '127.0.0.1' || host.endsWith('.workers.dev')
}

export function resolveTenant(
  hostname = window.location.hostname,
  search = window.location.search,
): TenantConfig {
  const host = hostname.toLowerCase().replace(/:\d+$/, '')

  if (isPreviewHost(host)) {
    const requestedCode = new URLSearchParams(search).get('tenant')?.toUpperCase()
    const previewTenant = tenants.find(tenant => tenant.code === requestedCode)
    if (previewTenant) return previewTenant
  }

  return tenants.find(tenant => tenant.domains.includes(host)) ?? tenants[0]
}

export const activeTenant = resolveTenant()

export function applyTenantBranding(tenant = activeTenant) {
  document.documentElement.dataset.company = tenant.code.toLowerCase()
  document.documentElement.dataset.companyId = tenant.companyId
  document.documentElement.style.setProperty('--acc-navy', tenant.primaryColor)

  document
    .querySelectorAll<HTMLImageElement>('img[src*="acc-isotipo-"]')
    .forEach(image => {
      image.src = tenant.logoUrl
      image.alt = tenant.tradeName
    })

  const replacements: Array<[string, string]> = [
    ['Aisha Cuello Constructora, SRL', tenant.legalName],
    ['Aisha Cuello Constructora SRL', tenant.legalName],
    ['Aisha Cuello Constructora', tenant.tradeName],
    ['datos@aishacuelloconstructora.com', tenant.email],
    ['info@aishacuelloconstructora.com', tenant.email],
    ['Proyectos ACC', `Proyectos ${tenant.code}`],
    ['Trazable para ACC.', `Trazable para ${tenant.code}.`],
    ['ACC valida el pago', `${tenant.code} valida el pago`],
    ['Recibido por ACC', `Recibido por ${tenant.code}`],
  ]

  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT)
  const textNodes: Text[] = []
  let node: Node | null = walker.nextNode()
  while (node) {
    textNodes.push(node as Text)
    node = walker.nextNode()
  }

  textNodes.forEach(textNode => {
    let value = textNode.nodeValue ?? ''
    replacements.forEach(([from, to]) => {
      value = value.replaceAll(from, to)
    })
    textNode.nodeValue = value
  })

  document.title = `${tenant.tradeName} · WebApp`

  const brand = document.querySelector<HTMLAnchorElement>('.brand')
  if (brand) brand.setAttribute('aria-label', `${tenant.tradeName}, inicio`)
}
